import {
  BadgeCheck, BookOpen, CalendarCheck, CircleCheck, Crown, Flag, Flame, Footprints, GraduationCap, Layers, Lock,
  Medal, NotebookPen, Target, Timer, Trophy,
} from 'lucide-react';

// O backend manda o nome do ícone do lucide (ex.: "badge-check")
const ICONS = {
  'badge-check': BadgeCheck,
  'book-open': BookOpen,
  'calendar-check': CalendarCheck,
  'circle-check': CircleCheck,
  crown: Crown,
  flag: Flag,
  flame: Flame,
  footprints: Footprints,
  'graduation-cap': GraduationCap,
  layers: Layers,
  medal: Medal,
  'notebook-pen': NotebookPen,
  target: Target,
  timer: Timer,
};

export const iconFor = (name) => ICONS[name] || Trophy;

export const TIERS = {
  gold: { label: 'Ouro', fg: 'var(--gold)', bg: 'var(--gold-bg)' },
  silver: { label: 'Prata', fg: 'var(--silver)', bg: 'var(--silver-bg)' },
  bronze: { label: 'Bronze', fg: 'var(--bronze)', bg: 'var(--bronze-bg)' },
  none: { label: 'Sem medalha', fg: 'var(--muted)', bg: 'var(--surface-muted)' },
};

export const tierOf = (tier) => TIERS[tier] || TIERS.none;

// Ícone da maestria: coroa no ouro, medalha na prata e no bronze, cadeado sem medalha
export const tierIcon = (tier) => (tier === 'gold' ? Crown : tier === 'silver' || tier === 'bronze' ? Medal : Lock);

export const fmtXp = (n) => Number(n || 0).toLocaleString('pt-BR');

/** "hoje", "ontem" ou "dd/mm". */
export function whenLabel(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  const day = (x) => new Date(x.getFullYear(), x.getMonth(), x.getDate()).getTime();
  const diff = Math.round((day(new Date()) - day(d)) / 86400000);
  if (diff === 0) return 'hoje';
  if (diff === 1) return 'ontem';
  return d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' });
}

/** "1 ouro · 2 prata · 2 bronze", só com os níveis que existem. */
export function tierCountsLabel(counts) {
  if (!counts) return undefined;
  const parts = [['gold', 'ouro'], ['silver', 'prata'], ['bronze', 'bronze']]
    .filter(([k]) => counts[k] > 0)
    .map(([k, label]) => `${counts[k]} ${label}`);
  return parts.length ? parts.join(' · ') : undefined;
}
